import ReplacementsHeader from "components/Replacements/ReplacementsHeader";
import { useParams } from "react-router";
import { useGetByIdQuery } from "features/api/orderApi.ts";
import ReplacementReason from "components/Replacements/components/ReplacementReason/ReplacementReason.tsx";

const ReplacementReasonPage = () => {
	const params = useParams();
	const { data } = useGetByIdQuery(params?.orderId ?? "");

	return (
		<div>
			<div data-testid="replacementReasons-replacementsHeader">
				<ReplacementsHeader orderDetail={data} />
			</div>
			<div data-testid="replacementReasons-replacementReasonContainer">
				<ReplacementReason orderDetail={data} />
			</div>
		</div>
	);
};

export default ReplacementReasonPage;
